module.exports = __webpack_public_path__ + "media/images/unavailable-image-2a35326663bef531918f5e635c4a8b09.jpg";